import React from "react";
import { generateRandomString } from "@italymondo/core-ui";
import loadable from "@loadable/component";
import {
  CMS_GalleryImageBlock,
  CMS_RichTextBlock,
  CMS_ShadowHeaderParagraphBlock,
  CMS_SignatureBlock,
} from "../../../generated/api";
import { ImagesBlock, StreamfieldContainer } from "./styles";

const ShadowHeaderParagraphBlock = loadable(
  () => import("./ShadowHeaderParagraphBlock"),
  {
    resolveComponent: (components) => components.ShadowHeaderParagraphBlock,
  }
);
const SignatureBlock = loadable(() => import("./SignatureBlock"), {
  resolveComponent: (components) => components.SignatureBlock,
});
const TextParagraphBlock = loadable(() => import("./TextParagraphBlock"), {
  resolveComponent: (components) => components.TextParagraphBlock,
});

type TpBlock =
  | CMS_ShadowHeaderParagraphBlock
  | CMS_GalleryImageBlock
  | CMS_RichTextBlock
  | CMS_SignatureBlock;

type PpStreamfieldBody = {
  blocks: Array<TpBlock>;
};

export function StreamfieldBody({
  blocks,
  ...rest
}: PpStreamfieldBody): React.ReactElement {
  function renderBlock(block: TpBlock): React.ReactElement | null {
    switch (block.__typename) {
      case "CMS_ShadowHeaderParagraphBlock":
        return (
          <ShadowHeaderParagraphBlock
            key={generateRandomString(5)}
            paragraph={block.paragraph}
            shadowHeader={block.shadowHeader}
          />
        );
      case "CMS_RichTextBlock":
        return (
          <TextParagraphBlock
            key={generateRandomString(5)}
            text={block.value}
          />
        );
      case "CMS_GalleryImageBlock":
        return (
          <ImagesBlock key={generateRandomString(5)} images={block.images} />
        );
      case "CMS_SignatureBlock":
        return (
          <SignatureBlock
            key={generateRandomString(5)}
            signature={block?.signature?.url}
          />
        );
      default:
        return null;
    }
  }
  return (
    <StreamfieldContainer {...rest}>
      {blocks.map((block) => renderBlock(block))}
    </StreamfieldContainer>
  );
}
